import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import Parse from "parse";
import "./ProfileSetting.css";
import { Select } from "../../Common/Forms";
import Spinner from "../../Common/Spinner";
import defaultImageUrl from "../../../assets/images/default.png";
import { getMembersSchedule } from "../../../actions/ProfileAction";

const $ = window.$;

function TeamScheduleModal({ isOpen = false, modalClose = () => {} }) {
  const dispatch = useDispatch();

  const modalId = "#team_scheduled_modal";
  var today = new Date();
  const [isLoading, setLoading] = useState(false);
  const [team, setTeam] = useState([]);
  const [dayFilter, setDayFilter] = useState(0);
  const [keyFilter, setKeyFilter] = useState("");
  const [userId] = useState(Parse.User.current().id);
  const [isAdmin, setIsAdmin] = useState(true);

  const daysOfWeek = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
  ];

  useEffect(() => {
    //
    const today = moment().format("dddd");
    const match = daysOfWeek.find((item) => item.label === today);
    setKeyFilter(match.value);
    handleGetMembersSchedule(match.value);
  }, []);

  const handleGetMembersSchedule = (day) => {
    setLoading(true);
    dispatch(getMembersSchedule(parseInt(day))).then((res) => {
      if (res.result.error_message && res.result.error_message === "User not authorized.") {
        setIsAdmin(false);
        setLoading(false);

      } else if (res.result.user_schedule && res.result.user_schedule.length > 0) {
        const teamSchedule = res.result.user_schedule.filter((item) => item.objectId !== userId);

        const sorted = teamSchedule.sort((a, b) => {
          if (a.status === "Online" && b.status !== "Online") return -1;
          if (a.status !== "Online" && b.status === "Online") return 1;
          return 0;
        });

        setTeam(sorted);
        setDayFilter(day);
        setLoading(false);
        setKeyFilter("status");
      }
    });
  };

  const handleSortBy = (filter) => {
    let sorted = [],
      chevron,
      newKey = filter;

    if (filter === "displayName") {
      sorted =
        keyFilter === "reverse"
          ? team.sort((a, b) => b[filter].localeCompare(a[filter]))
          : team.sort((a, b) => a[filter].localeCompare(b[filter]));
    } else if (filter === "status") {
      sorted =
        keyFilter === "reverse"
          ? team.sort((a, b) => {
              if (a.status === "Offline" && b.status !== "Offline") return -1;
              if (a.status !== "Offline" && b.status === "Offline") return 1;
              return 0;
            })
          : team.sort((a, b) => {
              if (a.status === "Online" && b.status !== "Online") return -1;
              if (a.status !== "Online" && b.status === "Online") return 1;
              return 0;
            });
    } else if (filter === "checkin") {
      sorted = team.sort((a, b) => {
        const aDay = a.schedules.find((day) => day.day === dayFilter);
        const bDay = b.schedules.find((day) => day.day === dayFilter);

        const aCheckIn = aDay ? aDay.check_in : null;
        const bCheckIn = bDay ? bDay.check_in : null;

        if (!aCheckIn && !bCheckIn) return 0;
        if (!aCheckIn) return 1;
        if (!bCheckIn) return -1;

        const aTime = moment(aCheckIn, "H:mm");
        const bTime = moment(bCheckIn, "H:mm");

        return keyFilter === "reverse"
          ? bTime.diff(aTime) // descending
          : aTime.diff(bTime); // ascending
      });
    } else if (filter === "checkout") {
      sorted = team.sort((a, b) => {
        const aDay = a.schedules.find((day) => day.day === dayFilter);
        const bDay = b.schedules.find((day) => day.day === dayFilter);

        const aCheckIn = aDay ? aDay.check_out : null;
        const bCheckIn = bDay ? bDay.check_out : null;

        if (!aCheckIn && !bCheckIn) return 0;
        if (!aCheckIn) return 1;
        if (!bCheckIn) return -1;

        const aTime = moment(aCheckIn, "H:mm");
        const bTime = moment(bCheckIn, "H:mm");

        return keyFilter === "reverse"
          ? bTime.diff(aTime) // descending
          : aTime.diff(bTime); // ascending
      });
    } else if (filter === "timezone") {
      sorted = team.sort((a, b) => {
        const aDay = a.schedules.find((day) => day.day === dayFilter);
        const bDay = b.schedules.find((day) => day.day === dayFilter);

        const aTimezone = aDay ? aDay.timezone : null;
        const bTimezone = bDay ? bDay.timezone : null;

        if (!aTimezone && !bTimezone) return 0;
        if (!aTimezone) return 1;
        if (!bTimezone) return -1;

        return keyFilter === "reverse" ? bTimezone.localeCompare(aTimezone) : aTimezone.localeCompare(bTimezone);
      });
    }
    setTeam(sorted);
    setKeyFilter(keyFilter === "reverse" ? newKey : "reverse");
  };

  const convertMilitaryToAmPm = (militaryTime) => {
    if (!militaryTime) return "Invalid Time";
    const [hourString, minuteString] = militaryTime.split(":");
    let hour = parseInt(hourString, 10);
    const minute = parseInt(minuteString, 10);
    const ampm = hour >= 12 ? "PM" : "AM";

    if (hour === 0) {
      hour = 12;
    } else if (hour > 12) {
      hour -= 12;
    }

    const formattedMinute = minute < 10 ? `0${minute}` : minute;

    return `${hour}:${formattedMinute} ${ampm}`;
  };

  useEffect(() => {
    if (isOpen) {
      $(modalId).modal({
        backdrop: "static",
        keyboard: false,
      });
      $(modalId).css({
        "z-index": "3000",
        position: "fixed",
      });
      $(modalId).modal("show");
    } else {
      $(modalId).modal("hide");
    }
  }, [isOpen]);

  return (
    <div id="team_scheduled_modal"
      // className="team-schedule-modal-container"
      >
      <div className="team-schedule-container">
        <div className="save-changes-flex" style={{ marginLeft: 5 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <div>
              <span
                className="d-none d-md-inline sched-header"
                style={{ fontWeight: "bold", fontSize: "14px" }}
              >
                Corp. Member Schedule
              </span>
              <div 
                className="current-day-label"
                style={{ fontSize: "12px" }}
              >
                Today, {moment().format("ddd, MMM DD")}
              </div>
            </div>
          </div>
        </div>
        {/* <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ margin: "0px 10px 0px 5px" }}>Day of Week</label>
          <div className="">
            <Select
              className="form-control"
              style={{ color: "##495057 !important" }}
              value={dayFilter}
              onChange={(e) => handleGetMembersSchedule(e.target.value)}
              disabled={isLoading}
            >
              {daysOfWeek.map((day) => (
                <option key={day.value} value={day.value}>
                  {day.label}
                </option>
              ))}
            </Select>
          </div>
        </div> */}
        {isAdmin && !isLoading && (
          <div className="team-table-container">
            <div className="">
              {isAdmin && team.length > 0 && (
                team.map((item, index) => (
                  <div className="team-sched-item" key={index}>
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <img
                        src={item.picture ? item.picture.url : defaultImageUrl}
                        alt=""
                        className="profile-image rounded-circle mr-2"
                        style={{ width: "40px", height: "40px" }}
                      />
                      <span
                        className="team-sched-online-badge"
                        style={{ backgroundColor: item.status === "Online" ? "#1fab42" : "grey" }}
                      >
                      </span>
                    </div>
                    <div className={`team-sched-name m-0 ${item.status === "Online" ? "active-team-schedule" : ""}`}>
                      {item.displayName}
                      <div style={{ fontSize: "11px" }}>
                        {item.schedules.length > 0 
                          ? convertMilitaryToAmPm(item.schedules[0].check_in_local) + " - " + convertMilitaryToAmPm(item.schedules[0].check_out_local)
                          : "-"
                        }
                      </div>
                    </div>
                  </div>
                ))
              )}
              {isAdmin && !isLoading && team.length === 0 && (
                <div className="em-container full-row">
                  <em>No Members found</em>
                </div>
              )}
            </div>
          </div>
        )}
        {isLoading && <CustomLoader isLoading={isLoading} />}
        {!isAdmin && !isLoading && (
          <div className="em-container full-row">
            <div className="d-flex" style={{alignItems: "center"}}>
              <i className="fas fa-lock hc-primary-text mx-1"></i>
              <span>Only admins can view member availability.</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const CustomLoader = ({ isLoading }) => {
  return (
    <div
      className="loader"
      style={{
        display: isLoading ? "inline-grid" : "none",
        position: "absolute",
        overflow: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <div align="center">
        <div className="loader-container">
          <div>
            <div className="loader-message">
              <span>Please wait...</span>
              <Spinner size={5} color={"#fbba09"} loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamScheduleModal;
